import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _UserMenuProfileTabContent_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './profile-tab-content.hbs'; */
import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import DoNotDisturbModal from "discourse/components/modal/do-not-disturb";
import UserStatusModal from "discourse/components/modal/user-status";
import { ajax } from "discourse/lib/ajax";
import DoNotDisturb from "discourse/lib/do-not-disturb";
import { userPath } from "discourse/lib/url";
import TEMPLATE from "./profile-tab-content.hbs";
import { setComponentTemplate } from "@ember/component";
const _extraItems = [];
export function addUserMenuProfileTabItem(item) {
  _extraItems.push(item);
}
export function resetUserMenuProfileTabItems() {
  _extraItems.clear();
}
let UserMenuProfileTabContent = (_class = (_UserMenuProfileTabContent_brand = /*#__PURE__*/new WeakSet(), class UserMenuProfileTabContent extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _UserMenuProfileTabContent_brand);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor2, this);
    _initializerDefineProperty(this, "userStatus", _descriptor3, this);
    _initializerDefineProperty(this, "modal", _descriptor4, this);
    _defineProperty(this, "saving", false);
  }
  get showToggleAnonymousButton() {
    return this.currentUser.can_post_anonymously || this.currentUser.is_anonymous;
  }
  get isInDoNotDisturb() {
    return !!_classPrivateGetter(_UserMenuProfileTabContent_brand, this, _get_doNotDisturbUntilDate);
  }
  get doNotDisturbDateTime() {
    return _classPrivateGetter(_UserMenuProfileTabContent_brand, this, _get_doNotDisturbUntilDate).getTime();
  }
  get showDoNotDisturbEndDate() {
    return !DoNotDisturb.isEternal(this.currentUser.get("do_not_disturb_until"));
  }
  get extraItems() {
    return _extraItems;
  }
  doNotDisturbClick() {
    if (this.saving) {
      return;
    }
    this.saving = true;
    if (this.currentUser.do_not_disturb_until) {
      return this.currentUser.leaveDoNotDisturb().finally(() => {
        this.saving = false;
      });
    } else {
      this.saving = false;
      this.args.closeUserMenu();
      this.modal.show(DoNotDisturbModal);
    }
  }
  setUserStatusClick() {
    this.args.closeUserMenu();
    this.modal.show(UserStatusModal, {
      model: {
        status: this.currentUser.status,
        pauseNotifications: this.currentUser.isInDoNotDisturb(),
        saveAction: (status, pauseNotifications) => this.userStatus.set(status, pauseNotifications),
        deleteAction: () => this.userStatus.clear()
      }
    });
  }
  async toggleAnonymous() {
    await ajax(userPath("toggle-anon"), {
      type: "POST"
    });
    window.location.reload();
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userStatus", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "doNotDisturbClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "doNotDisturbClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserStatusClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUserStatusClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAnonymous", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAnonymous"), _class.prototype)), _class);
function _get_doNotDisturbUntilDate(_this) {
  if (!_this.currentUser.get("do_not_disturb_until")) {
    return;
  }
  const date = new Date(_this.currentUser.get("do_not_disturb_until"));
  if (date < new Date()) {
    return;
  }
  return date;
}
export { UserMenuProfileTabContent as default };
setComponentTemplate(TEMPLATE, UserMenuProfileTabContent);